
export const STORAGE_KEYS = {
    ACCESS_TOKEN: "access_token",
    EXPIRES_AT: "expires_at",
    PASSWORD_EXPIRES_IN: "pwd_expires_in",
    HOME_ACCOUNT: "homeAccount",
    SEC_ARCHIVE: "secArchive",
    SEC_MARK_READ: "secMarkRead",
    SEC_SAVE: "secSave",
    SEC_SIGN: "secSign",
    USER_NAME: "userName",
    USER_ID: "userId",
    USER_TYPE: "userType",
    EMAIL: "email",
    DICTATOR_ID: "dictatorId",
    ROLES: "roles",
    SSO_IDENTITY_COLUMN: "ssoIdentityColumn",
    IS_VALID_LOGIN: "isValidLogin",
    GA_USER_ID: "gaUserId",
    CENTER_NAME: "centerName",
    ACTIVE_ACCOUNT: "activeAccount",
    USER_ACCOUNTS: "userAccounts",
    CAN_SWITCH_ACCOUNTS: "canSwitchAccounts",
    IS_CODING: "isCoding",
    FROM_DATE: "fromDate",
    TO_DATE: "toDate",
    CAN_VIEW_DOCUMENT_UPLOAD: "canViewDocumentUpload",
    SN_USER: "snuser",
    SSO_IDENTITY: "ssoIdentity",
    Name: "name",
    ADD_EDIT_USER: "AddEditUser",
    SCHEME: "scheme",
    ARCHIVE: "Archive",
    MARK_READ: "MarkRead",
    SAVE: "Save",
    SIGN: "Sign",
    ADMIN: "Admin",
    FACILITY_ADMIN: "FacilityAdmin",
    EDITOR: "Editor",
    SUPPORT_ADMIN: "SupportAdmin",
    CODING_EDITOR: "Coding Editor",
    ADMINISTRATOR: "Administrator",
    SERVER_ADMIN: "ServerAdmin"
};



// WEBPACK FOOTER //
// ./src/components/constants/StorageKeys.js